import { render } from "./ReservationFlights.vue?vue&type=template&id=3f589594"
import script from "./ReservationFlights.vue?vue&type=script&lang=js"
export * from "./ReservationFlights.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__